const Index = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/CourseMapIndex')
const CalendarMainPage = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/components/CourseMapMainPage')
const CoursePlanMainPage = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/components/coursePlan/CoursePlanMainPage.vue')
const UnitCompareCurriculum = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/components/coursePlan/CompareCurriculum.vue')
const UnitCalendarYear = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/components/unitCalendar/UnitCalendarYear')
const CalendarMonth = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/components/unitCalendar/UnitCalendarMonth')
const AddNewUnit = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/subpages/AddNewUnit')
const AddNewLesson = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/subpages/AddNewLesson')
const EditUnit = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/subpages/EditUnit')
const ShareCourseMap = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/subpages/ShareCourseMap')
const RecycleBin = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/subpages/RecycleBin')
const DescriptionEditor = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/subpages/DescriptionEditor')
const LessonsWithNoUnitsIndex = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/subpages/lessonsWithNoUnits/LessonsWithNoUnitsIndex')
const LessonsWithNoUnits = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/subpages/lessonsWithNoUnits/LessonsWithNoUnits')
const LessonsWithNoUnitsAddNewLesson = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/subpages/lessonsWithNoUnits/LessonsWithNoUnitsAddNewLesson')
const LessonsWithNoUnitsRecycleBin = () => import(/* webpackChunkName: "course-map" */ '@/pages/courseMap/subpages/lessonsWithNoUnits/LessonsWithNoUnitsRecycleBin')

export default [
  {
    path: '/develop/course-map/:id',
    name: 'CourseMap',
    component: Index,
    children: [
      {
        path: 'unit-calendar',
        name: 'UnitCalendar',
        component: CalendarMainPage,
        redirect: { name: 'UnitCalendarYear' },
        children: [
          {
            path: 'year',
            name: 'UnitCalendarYear',
            component: UnitCalendarYear
          },
          {
            path: 'month',
            name: 'CalendarMonth',
            component: CalendarMonth
          }
        ]
      },
      {
        path: 'lessons-with-no-units',
        name: 'LessonsWithNoUnitsIndex',
        component: LessonsWithNoUnitsIndex,
        redirect: { name: 'LessonsWithNoUnits' },
        children: [
          {
            path: '/',
            name: 'LessonsWithNoUnits',
            component: LessonsWithNoUnits
          },
          {
            path: 'add-new-lesson',
            name: 'LessonsWithNoUnitsAddNewLesson',
            component: LessonsWithNoUnitsAddNewLesson
          },
          {
            path: 'recycle-bin',
            name: 'LessonsWithNoUnitsRecycleBin',
            component: LessonsWithNoUnitsRecycleBin
          }
        ]
      },
      {
        path: 'course-plan',
        name: 'CoursePlan',
        component: CoursePlanMainPage,
        redirect: { name: 'UnitCompareCurriculum' },
        children: [
          {
            path: 'curriculum',
            name: 'UnitCompareCurriculum',
            component: UnitCompareCurriculum
          },
          {
            path: 'analytics',
            name: 'UnitCompareAnalytics',
            component: UnitCompareCurriculum
          }
        ]
      },
      {
        path: 'add-new-unit',
        name: 'CourseMapAddNewUnit',
        component: AddNewUnit
      },
      {
        path: 'add-new-lesson',
        name: 'CourseMapAddNewLesson',
        component: AddNewLesson
      },
      {
        path: 'edit-unit/:unitId',
        name: 'CourseMapEditUnit',
        component: EditUnit
      },
      {
        path: 'recycle-bin',
        name: 'CourseMapRecycleBin',
        component: RecycleBin
      },
      {
        path: 'description',
        name: 'CourseMapDescriptionEditor',
        component: DescriptionEditor
      },
      {
        path: 'share',
        name: 'ShareCourseMap',
        component: ShareCourseMap
      }
    ]
  }
]
